import "backbone";


let RunnedAppModel = Backbone.Model.extend("RunnedAppModel", {
    defaults: {
        title: ""
    },

    remove() {
        this.trigger("remove");
    }
});

export default RunnedAppModel;
